import { useEffect, useMemo, useState } from "react";
import _ from "lodash";
import { BranchesOutlined } from "@ant-design/icons";
import { Col, Row, Table } from "antd";
import Breadcrumbs from "../../components/Breadcrumbs";
import ProjectInformation from "../../components/ProjectInformation";
import Title from "../../components/Title";
import DashboardPages from "../../Dashboard/DashboardPages";
import Tables from "../../components/Tables";
import {
  TYPE_GET_DATE,
  defineColumnsDetailTableHaloGame,
} from "../../../helper/const";
import { useSelector } from "react-redux";
import { selectorDataHalotel } from "../../../redux/selector";
import { useDispatch } from "react-redux";
import {
  formatDataNumberToen,
  getDateChangeTime,
} from "../../../helper/helper";
import FilterTime from "../../components/FilterTime";
import { apiRevenueHalotel } from "../../../api/ApiHalotel";
import dayjs from "dayjs";
import { idProject } from "../../../helper/const";
import { getDataRevenueHalotel } from "../../../redux/Future/Halotel/action";
import styled from "styled-components";

export default function RevenueUnitel() {
  const dispatch = useDispatch();

  const [endDate, setEndDate] = useState(getDateChangeTime(TYPE_GET_DATE.now));
  const [startDate, setStartDate] = useState(
    getDateChangeTime(TYPE_GET_DATE.oneMonthAgo)
  );

  useEffect(() => {
    dispatch(getDataRevenueHalotel(apiRevenueHalotel(startDate, endDate)));
  }, [startDate, endDate]);

  const { revenue = {} } = useSelector(selectorDataHalotel);
  const dataList = revenue.result?.dataList;



  let data = (dataList || []).map(item => ({
    ...item,
    "Total Revenue": item.total_revenue,
    "Total Charge": item.total_register + item.total_renew,
  }));

  const dataTable = [...data].sort((a, b) => new Date(b.report_date) - new Date(a.report_date));


  const dataDetail = {
    data,
    xField: "report_date",
    yField: ["Total Revenue", "Total Charge"],
  };

 
//     let transformed = [];
//   (dataList || []).forEach(item => {
//     transformed.push({ time: item.time, value: item.total_revenue, type: "Doanh thu" });
//     transformed.push({ time: item.time, value: item.charge_total, type: "Nạp tiền" });
//   });
// 
//   console.log('transformed: ', transformed);
// 
//   const dataDetail = {
//     data: transformed,
//     isGroup: true, // hoặc isStack: true nếu muốn chồng cột
//     xField: "time",
//     yField: "value",
//     seriesField: "type",
//     legend: { position: "top" },
//     tooltip: {
//       fields: ["time", "value", "type"],
//     },
//   };

  return (
    <Container>
      <Breadcrumbs data={["Halogame"]} />
      <div className="container-dashboard">
        <div className="d-flex justify-content-end mb-2">
          <FilterTime
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
          />
        </div>

        <Row className="panel panel-sortable mt-4">
          <Title titleName="Overview">
            <BranchesOutlined />
          </Title>
          <Col span={24} className="container-revenue">
            <DashboardPages
              dataDashboard={dataDetail}
              isHiddenContainer
              width={1100}
            />
          </Col>
          <Col span={24} className="mt-4 container-item">
            <h4 className="pt-3 pe-3 pb-2">Overview statistics table:</h4>
            <Row>
              <Col span={24}>
                <Table
                  columns={defineColumnsDetailTableHaloGame}
                  dataSource={dataTable}
                  pagination={false}
                  summary={(pageData) => {
                    const fields = [
                      "total_register",
                      "total_renew",
                      "total_cancel",
                      "total_revenue_register",
                      "total_revenue_renew",
                      "total_revenue",
                    ];

                    const totals = fields.map((field) =>
                      pageData.reduce((sum, row) => sum + (row[field] || 0), 0)
                    );

                    return (
                      <Table.Summary.Row>
                        <Table.Summary.Cell index={0}>
                          <p>Total</p>
                        </Table.Summary.Cell>
                        {totals.map((value, i) => (
                          <Table.Summary.Cell key={fields[i]} index={i + 1}>
                            {value.toLocaleString("en-US")}
                          </Table.Summary.Cell>
                        ))}
                      </Table.Summary.Row>
                    );
                  }}
                />

              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </Container>
  );
}

const Container = styled.div`
  .ant-table-container {
    overflow-x: auto;
  }

  .panel-sortable {
  }

  .container-revenue {
    width: 100%;
    padding: 0.25rem 2rem;
  }

  @media (max-width: 1200px) {
    .container-revenue {
      width: 100%;
      padding: 0.25rem 1rem;
    }
  }

  @media (max-width: 768px) {
    .chart-container__unitel {
      margin-top: 1rem;
    }
  }
`;
